import { RequestMethods } from "../../constants";
export const getTokenRequestParameters = (url, parser, requestProperties) => {
    const headers = Object.assign({ "Content-Type": "application/json" }, requestProperties === null || requestProperties === void 0 ? void 0 : requestProperties.headers);
    const options = Object.assign(Object.assign({ method: RequestMethods.GET }, requestProperties), { headers });
    return { url, parser, options };
};
//# sourceMappingURL=getTokenRequestParameters.js.map